// CSR-674: trimmed. Pre-CSR-674 this file iterated bulk policy/insured
// arrays client-side. Those iterations now live in SQL behind
// /api/policies/stats, /api/insureds/stats, /api/policies/premium-by-month.
// What remains are formatters used by InsuredsListDialog + DateRangeFilter.

export type DateRangeKey = "today" | "yesterday" | "thisMonth" | "lastMonth" | "custom";

export function formatCurrencyCompact(value: number): string {
  if (!Number.isFinite(value) || value === 0) return "$0";
  return `$${Math.round(value).toLocaleString()}`;
}

export function formatInitials(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return "--";
  if (words.length === 1) return words[0]!.slice(0, 2).toUpperCase();
  return (words[0]![0]! + words[1]![0]!).toUpperCase();
}
